import utilsApi from '../../assets/js/utils';

import config from '../config/index';

export default utilsApi.creatApi({

    // 获取用户绑定信息
    getUserBindInfo: ['post', config.deadlockUrl + '/user/getUserBindInfo'],
    // 用户绑定
    userBind: ['post', config.deadlockUrl + '/user/userBind'],
    // 获取用户总战绩信息
    getUserTrackerInfo: ['get', config.deadlockUrl + '/tracker/getUserTrackerInfo'],
    // 获取对局战绩列表
    getUserMatchTracker: ['get', config.deadlockUrl + '/tracker/getUserMatchTracker'],
    // 获取用户好友列表
    getUserSteamFriend: ['get', config.deadlockUrl + '/tracker/getUserSteamFriend'],
    // 刷新信息
    update: ['get', config.deadlockUrl + '/tracker/update'],
    // 获取刷新状态
    getUpdateStatus: ['get', config.deadlockUrl + '/tracker/getUpdateStatus'],

    // 上报统计，2024-5-31下线此统计功能
    reportStatus: ['get', "https://router3.gamersky.com/@/importantLog/valorant_stats/record"],

    // 获取用户绑定的steamId
    getBindSteamByUserId: ['get','//router5.gamersky.com/@/gameInfo/userData/steam/userBaseInfo'],

});